import { render, staticRenderFns } from "./deposit.vue?vue&type=template&id=4fba1c78&scoped=true&"
import script from "./deposit.vue?vue&type=script&lang=js&"
export * from "./deposit.vue?vue&type=script&lang=js&"
import style0 from "./deposit.vue?vue&type=style&index=0&id=4fba1c78&prod&scoped=true&lang=css&"
import style1 from "./deposit.vue?vue&type=style&index=1&id=4fba1c78&prod&lang=scss&scoped=true&"
import style2 from "./deposit.vue?vue&type=style&index=2&id=4fba1c78&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4fba1c78",
  null
  
)

export default component.exports